"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const icons_vue_1 = require("@ant-design/icons-vue");
const complex_utils_1 = require("complex-utils");
const MenuData_1 = __importDefault(require("@/class/MenuData"));
const develop_1 = __importDefault(require("@/data/develop"));
const router_1 = __importDefault(require("../router"));
const role_1 = __importStar(require("./role"));
const originMenuList = [
    {
        path: '/home',
        name: '首页',
        icon() {
            return (0, vue_1.h)(icons_vue_1.HomeOutlined);
        },
        component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/home/index.vue')))
    },
    {
        path: '/overdue',
        redirect: '/overdue/list',
        name: '逾期处理',
        icon() {
            return (0, vue_1.h)(icons_vue_1.HistoryOutlined);
        },
        component: () => Promise.resolve().then(() => __importStar(require('./../layout/PureLayout.vue'))),
        children: [
            {
                path: '/overdue/list',
                name: '逾期记录',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/overdue/list/index.vue')))
            },
            {
                path: '/overdue/info/:id',
                name(route) {
                    return '逾期记录详情' + route.params.id;
                },
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/overdue/info/index.vue'))),
                hidden: true,
            },
            {
                path: '/overdue/guarantor/list',
                name: '追加担保人',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/overdue/guarantor/list/index.vue'))),
                role: role_1.default.guarantor.list
            },
            {
                path: '/overdue/guarantor/info/:overdueRecordId/:id',
                name(route) {
                    if (route && route.params.id && route.params.id !== 'build') {
                        return '追加担保人详情' + route.params.id;
                    }
                    else {
                        return '追加担保人新增';
                    }
                },
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/overdue/guarantor/info/index.vue'))),
                role: role_1.default.guarantor.edit,
                hidden: true
            }
        ]
    },
    {
        path: '/external',
        redirect: '/external/vehicle',
        name: '外访管理',
        icon() {
            return (0, vue_1.h)(icons_vue_1.SendOutlined);
        },
        component: () => Promise.resolve().then(() => __importStar(require('./../layout/PureLayout.vue'))),
        children: [
            {
                path: '/external/vehicle',
                name: '车辆明细',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/external/vehicle/list/index.vue'))),
            },
            {
                path: '/external/preservation/list',
                name: '车辆保全申请',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/external/preservation/list/index.vue'))),
                role: role_1.default.preservation.list
            },
            {
                path: '/external/preservation/info/:id/:overdueRecordOrFlowId/:flowKey',
                name(route) {
                    if (route && route.params.id && route.params.id !== 'build') {
                        return '车辆保全申请详情' + route.params.id;
                    }
                    else {
                        return '车辆保全申请新增';
                    }
                },
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/external/preservation/info/index.vue'))),
                role: role_1.default.preservation.edit,
                hidden: true,
                tab: 'hidden'
            },
        ]
    },
    {
        path: '/handle',
        redirect: '/handle/redeem/list',
        name: '处置管理',
        icon() {
            return (0, vue_1.h)(icons_vue_1.SwapOutlined);
        },
        component: () => Promise.resolve().then(() => __importStar(require('./../layout/PureLayout.vue'))),
        children: [
            {
                path: '/handle/redeem/list',
                name: '车辆赎回申请',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/handle/redeem/list/index.vue'))),
                role: role_1.default.redeem.list,
            },
            {
                path: '/handle/redeem/info/:id/:overdueRecordOrFlowId/:flowKey',
                name(route) {
                    if (route && route.params.id && route.params.id !== 'build') {
                        return '车辆赎回申请详情' + route.params.id;
                    }
                    else {
                        return '车辆赎回申请新增';
                    }
                },
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/handle/redeem/info/index.vue'))),
                role: role_1.default.redeem.edit,
                hidden: true,
                tab: 'hidden',
            },
            {
                path: '/handle/dispose/list',
                name: '车辆处置申请',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/handle/dispose/list/index.vue'))),
                role: role_1.default.dispose.list,
            },
            {
                path: '/handle/dispose/info/:id/:overdueRecordOrFlowId/:flowKey',
                name(route) {
                    if (route && route.params.id && route.params.id !== 'build') {
                        return '车辆处置申请详情' + route.params.id;
                    }
                    else {
                        return '车辆处置申请新增';
                    }
                },
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/handle/dispose/info/index.vue'))),
                role: role_1.default.dispose.edit,
                hidden: true,
                tab: 'hidden',
            },
        ]
    },
    {
        path: '/litigation',
        redirect: '/litigation/pending',
        name: '法诉管理',
        icon() {
            return (0, vue_1.h)(icons_vue_1.ReadOutlined);
        },
        component: () => Promise.resolve().then(() => __importStar(require('./../layout/PureLayout.vue'))),
        children: [
            {
                path: '/litigation/contract/pending',
                name: '待诉合同',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/litigation/contract/pending/index.vue'))),
                role: role_1.default.litigation.contract.pending,
            },
            {
                path: '/litigation/application/list',
                name: '诉讼申请',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/litigation/application/list/index.vue'))),
                role: role_1.default.litigation.application.list,
            },
            {
                path: '/litigation/contract/submit',
                name: '已提交待诉合同',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/litigation/contract/submit/index.vue'))),
                role: role_1.default.litigation.contract.submit,
            },
            {
                path: '/litigation/application/info/:id/:flowId/:flowKey',
                name(route) {
                    if (route && route.params.id && route.params.id !== 'build') {
                        return '诉讼申请详情' + route.params.id;
                    }
                    else {
                        return '诉讼申请新增';
                    }
                },
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/litigation/application/info/index.vue'))),
                role: role_1.default.litigation.application.edit,
                hidden: true,
                tab: 'hidden',
            },
            {
                path: '/litigation/log',
                name: '诉讼记录',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/litigation/log/list/index.vue'))),
                role: role_1.default.litigation.log.list,
            },
            {
                path: '/litigation/log/info/:id/:flowKey/:overdueRecordId',
                name(route) {
                    if (route && route.params.id && route.params.id !== 'build') {
                        return '诉讼记录详情' + route.params.id;
                    }
                    else {
                        return '诉讼记录新增';
                    }
                },
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/litigation/log/info/index.vue'))),
                role: role_1.default.litigation.log.list,
                hidden: true,
                tab: 'hidden',
            },
            {
                path: '/litigation/execute/info/:id/:flowId/:flowKey',
                name(route) {
                    if (route && route.params.id && route.params.id !== 'build') {
                        return '诉讼执行详情' + route.params.id;
                    }
                    else {
                        return '诉讼执行新增';
                    }
                },
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/litigation/execute/info/index.vue'))),
                hidden: true,
                tab: 'hidden',
            },
            {
                path: '/litigation/seize/info/:id/:flowId/:flowKey',
                name(route) {
                    if (route && route.params.id && route.params.id !== 'build') {
                        return '诉讼查封详情' + route.params.id;
                    }
                    else {
                        return '诉讼查封新增';
                    }
                },
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/litigation/seize/info/index.vue'))),
                hidden: true,
                tab: 'hidden',
            },
        ]
    },
    {
        path: '/system',
        redirect: '/system/serviceProvider',
        name: '配置管理',
        icon() {
            return (0, vue_1.h)(icons_vue_1.SettingOutlined);
        },
        component: () => Promise.resolve().then(() => __importStar(require('./../layout/PureLayout.vue'))),
        children: [
            {
                path: '/system/serviceProvider',
                name: '服务商管理',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/system/service-provider/index.vue'))),
                role: role_1.default.serviceProvider.list
            },
            {
                path: '/system/parkingPoint',
                name: '停车点管理',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/system/parking-point/index.vue'))),
                role: role_1.default.parkingPoint.list
            },
            {
                path: '/system/assignRule',
                name: '分派规则管理',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/system/assign-rule/index.vue'))),
                role: role_1.default.assignRule.list
            },
            {
                path: '/system/area',
                name: '区域管理',
                component: () => Promise.resolve().then(() => __importStar(require('@/pages/index/views/system/area/index.vue'))),
                role: role_1.default.area.list
            },
        ]
    },
];
let unauthorized = false;
(0, complex_utils_1.resetEnvData)(() => {
    if ((0, complex_utils_1.getLocalData)('unauthorized') === '1') {
        unauthorized = true;
    }
}, {
    info: '开发环境下展示全部未经授权的页面！'
});
function changeMenu(menu, target = 403) {
    // 更换模板为未授权页面
    if (target === 403) {
        menu.component = () => Promise.resolve().then(() => __importStar(require('@/views/exception/403.vue')));
    }
    else {
        menu.component = () => Promise.resolve().then(() => __importStar(require('@/views/exception/404.vue')));
    }
    menu.hidden = true;
}
function parseMenuByUnauthorized(menu) {
    menu.unauthorized = unauthorized;
    if (!unauthorized) {
        // 正常权限需要更换模板为未授权页面
        changeMenu(menu);
        return true;
    }
    return false;
}
function getMenu(menuList) {
    let num = 0;
    menuList.forEach(item => {
        if (item.children) {
            const childNum = getMenu(item.children);
            if (childNum === 0) {
                // 无子类则隐藏父类
                item.hidden = true;
            }
        }
        if (item.developing && !develop_1.default.getData()) {
            // 生产环境下的开发页面替换为404页面:调试模式不更改
            changeMenu(item, 404);
        }
        if (!(0, role_1.hasRole)(item.role)) {
            if (!parseMenuByUnauthorized(item)) {
                // 菜单更改则判断为有子类
                num++;
            }
        }
        else {
            num++;
        }
    });
    return num;
}
const menu = (0, vue_1.reactive)(new MenuData_1.default({
    $getData() {
        return new Promise((resolve) => {
            getMenu(originMenuList);
            this.list = this.$formatData(originMenuList);
            resolve({ status: 'success' });
        });
    },
    $addRouter() {
        if (this.list.length > 0) {
            router_1.default.addRoute({
                path: '/',
                redirect: this.list[0].redirect || this.list[0].path,
                component: () => Promise.resolve().then(() => __importStar(require('../layout/TabLayout.vue'))),
                children: [
                    ...this.list
                ]
            });
        }
        router_1.default.addRoute({
            path: '/:catchAll(.*)',
            redirect: '/404'
        });
    }
}));
exports.default = menu;
